export { SpecialColumn, isScoringColumn, isScoringType } from '@discngine/moosa-models';
import upperFirst from 'lodash/upperFirst';
import { useState, useMemo } from 'react';

const getNamedObject = (obj, prefix, suffix) => {
    const res = Object.entries(obj).map(([key, value]) => [
        `${prefix !== null && prefix !== void 0 ? prefix : ''}${prefix ? upperFirst(key) : key}${upperFirst(suffix)}`,
        value,
    ]);
    return Object.fromEntries(res);
};

const isNonNullable = (value) => value !== null && value !== undefined;

const useStatus = () => {
    const [status, setStatus] = useState('idle');
    return useMemo(() => ({
        status,
        setStatus,
        isLoading: status === 'loading',
        isIdle: status === 'idle',
        isError: status === 'error',
        isSuccess: status === 'success',
    }), [status]);
};

export { getNamedObject, isNonNullable, useStatus };
//# sourceMappingURL=index.js.map
